var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackfacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4002 13.2H15.6002C14.2802 13.2 13.2002 14.28 13.2002 15.6V32.4C13.2002 33.7212 14.2802 34.8 15.6002 34.8H24.0002V26.4H21.6002V23.43H24.0002V20.97C24.0002 18.3732 25.4546 16.5492 28.5194 16.5492L30.683 16.5516V19.6776H29.2466C28.0538 19.6776 27.6002 20.5728 27.6002 21.4032V23.4312H30.6818L30.0002 26.4H27.6002V34.8H32.4002C33.7202 34.8 34.8002 33.7212 34.8002 32.4V15.6C34.8002 14.28 33.7202 13.2 32.4002 13.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackfacebook);
export default __webpack_public_path__ + "static/media/blackfacebook.33f5007bdb9a1e4dd3e4b8ca0e7acd0a.svg";
export { ForwardRef as ReactComponent };